import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// actions
import {
	getCityApi,
	setCityData,
	getActivitiesAndFacilitiesApi,
	setActivityFacilityData,
} from "../../../configureStore";
// Components
import OutsideClickHandler from "react-outside-click-handler";
import SelectAutoComplete from "./selectAutocomplete";
import SelectLoader from "./selectLoader";

const AjaxSelect = (props) => {
	const global = useSelector((state) => state.global);
	const dispatch = useDispatch();
	const [input, setInput] = useState("");
	const [hasData, setHasData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [timer, setTimer] = useState(null);
	const [cityDataFetch] = getCityApi.endpoints.fetchCityData.useLazyQuery();
	const [facilitiesDataFetch] =
		getActivitiesAndFacilitiesApi.endpoints.fetchFacilitiesData.useLazyQuery();
	const [activitiesDataFetch] =
		getActivitiesAndFacilitiesApi.endpoints.fetchActivitiesData.useLazyQuery();
	useEffect(() => {
		if (props.defaultInputValue === "" && props.name === "" && input !== "") {
			setInput("");
			// clearInput();
			return;
		} else if (props.defaultInputValue !== "" || input || props.name !== "") {
			if (props.inverted) {
				setInput(props.name);
			} else {
				setInput(props.defaultInputValue);
			}
			setIsLoading(false);
		}
	}, [props.defaultInputValue, props.inverted,props.name]);
	// utility functions and events
	const onChange = (e) => {
		const inputValue = e.currentTarget.value;
		if (inputValue.length >= 3) {
			setIsLoading(true);
		} else {
			setHasData(null);
		}
		getSelectData(inputValue);
		setInput(inputValue);
	};

	const onClick = (e) => {
		setHasData(null);
		setInput(e.currentTarget.innerText);
		globalStateData(e.currentTarget.innerText, false);
	};
	const onBlur = (e) => {
		setIsLoading(false);
		const inputValue = e.currentTarget.value;
		if (timer) {
			clearTimeout(timer);
			setTimer(null);
		}
		// setHasData(null);
		if (inputValue.length > 0) {
			setInput(inputValue);
			globalStateData(inputValue, false);
		}
	};
	const onKeyDown = (e) => {
		if (e.keyCode === 13) {
			// enter key
			if (timer) {
				clearTimeout(timer);
				setTimer(null);
			}
			setIsLoading(false);
			setHasData(null);

			globalStateData(input, false);
		}
	};

	const outsideClick = () => {
		setHasData(null);
	};

	const clearInput = (e) => {
		setInput("");
		setHasData(null);
		globalStateData("", true);
	};

	// send data to global state
	const globalStateData = (inputValue, clear) => {

		if (props.resultsType === "activityFacility") {
			dispatch(
				setActivityFacilityData({ name: inputValue, value: inputValue }),
			);
		} else if (props.resultsType === "city") {
			if (props.inverted && !clear && inputValue === "") {
				dispatch(setCityData({ name: props.name, value: "" }));
			} else if (props.inverted && clear && inputValue === "") {
				dispatch(setCityData({ name: "", value: "" }));
			} else {
				dispatch(setCityData({ name: inputValue, value: inputValue }));
			}
		}
	};

	// Requests
	const searchFacilityAndActivity = async (input) => {
		const responseFacility = await facilitiesDataFetch({
			url: global.url,
			query: input,
		});
		const responseActivity = await activitiesDataFetch({
			url: global.url,
			query: input,
		});
		let labels = [];
		if (responseFacility.isSuccess && responseActivity.isSuccess) {
			labels.push({
				label: global.localization.activity,
				options: responseActivity.data.activities.length
					? responseActivity.data.activities
					: null,
			});
			labels.push({
				label: global.localization.facility,
				options: responseFacility.data.length ? responseFacility.data : null,
			});
			return labels;
		} else {
			console.error(
				responseFacility.endpointName + responseFacility.isError,
				responseActivity.endpointName + responseActivity.isError,
			);
			return [];
		}
	};
	const searchCity = async (input) => {
		const response = await cityDataFetch({ url: global.url, query: input });
		if (response.isSuccess) {
			return response.data;
		} else {
			console.error(response.endpointName + response.isError);
			return [];
		}
	};

	// Option builders
	const setActivityFacilityOptions = (options) => {
		let activityOptions = {
			label: null,
			options: [],
		};
		let facilityOptions = {
			label: null,
			options: [],
		};
		let arr = [];
		if (options[0].options) {
			activityOptions.label = options[0].label;
			activityOptions.options = options[0].options.map((option) => {
				return {
					label: option.name,
					value: option.activityId,
				};
			});
			arr.push(activityOptions);
		}
		if (options[1].options !== null) {
			facilityOptions.label = options[1].label;
			facilityOptions.options = options[1].options.map((option) => {
				return {
					label: option.name,
					value: option.facilityId,
				};
			});
			arr.push(facilityOptions);
		}
		renderOptions(arr);
	};
	const setCityOptions = (options) => {
		let optionsObj = {
			label: null,
			options: [],
		};
		const filterArr = [];
		options.forEach((option) => {
			optionsObj.options.push({ label: option.name, value: option.name });
		});
		filterArr.push(optionsObj);
		renderOptions(filterArr);
	};

	// add  debounce  on input and get results from api
	const getSelectData = (inputValue) => {
		if (timer) {
			clearTimeout(timer);
			setTimer(null);
		}
		if (inputValue.length < 3 || inputValue === "") {
			return;
		}

		setTimer(
			setTimeout(() => {
				sendRequest(inputValue);
			}, 1000),
		);
	};

	const sendRequest = (inputValue) => {
		new Promise((resolve) => {
			if (props.resultsType === "activityFacility") {
				resolve(searchFacilityAndActivity(inputValue));
			} else if (props.resultsType === "city") {
				resolve(searchCity(inputValue));
			}
		}).then((reponseValue) => {
			setIsLoading(false);
			if (reponseValue !== "undefined" && reponseValue.length < 1) {
				renderOptions([]);
				return;
			}
			if (props.resultsType === "activityFacility") {
				setActivityFacilityOptions(reponseValue);
			} else if (props.resultsType === "city") {
				setCityOptions(reponseValue);
			}
		});
	};

	// Renders
	const renderOptions = (optionsObj) => {
		let content = null;
		if (optionsObj.length) {
			content = optionsObj.map((items, index) => {
				if (items.options.length) {
					return (
						<SelectAutoComplete
							key={"obj" + index}
							list={items}
							callback={onClick}
						/>
					);
				}
				return null;
			});
		} else {
			content = (
				<div className="search-c__option disable">
					{global.localization.noOptionsMessage}
				</div>
			);
		}
		const resultsList = (
			<div className="search-c__menu">
				<div className="search-c__menu-cont">{content}</div>
			</div>
		);

		setHasData(resultsList);
	};
	return (
		<OutsideClickHandler onOutsideClick={outsideClick}>
			<div className="search-c">
				<input
					type="text"
					name={props.resultsType}
					className="search-c__control"
					onInput={onChange}
					onKeyDown={onKeyDown}
					onBlur={onBlur}
					autoComplete="off"
					placeholder={props.placeholder}
					value={input}
				/>
				{input !== "" ? (
					<button
						type="button"
						className="search-c__clear-indicator"
						onClick={clearInput}
						aria-label="close">
						X
					</button>
				) : null}
			</div>
			{isLoading && input.length > 2 ? (
				<SelectLoader label={global.localization.filtersLoading} />
			) : null}
			{!isLoading && hasData}
		</OutsideClickHandler>
	);
};

export default AjaxSelect;
